import { Subject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';

export class ModalDialog {
  public title: string;
  public message: string;
  public showFooter: boolean;
  public onOkSubject = new Subject();
  public onCancelSubject = new Subject();

  constructor(title: string, message: string, showFooter: boolean = false) {
    this.title = title;
    this.message = message;
    this.showFooter = showFooter;  
  }
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  public dialogSubject = new Subject<ModalDialog>();

  private dialogStack: ModalDialog[] = [];
  private subscription = new Subscription();

  constructor() {
  }

  public showMessageDialog(title: string, message: string): ModalDialog {
    const dialog = new ModalDialog(title, message);
    return this.showDialog(dialog);    
  }

  public showOkCancelDialog(title: string, message: string): ModalDialog {
    const dialog = new ModalDialog(title, message, true);
    return this.showDialog(dialog);  
  }

  public closeDialog(dialog: ModalDialog) {
    const dlgIndex = this.dialogStack.findIndex((dlg) => dlg === dialog);
    if (dlgIndex < 0) {
      return;
    }
    this.dialogStack.splice(dlgIndex, 1);
    if (dlgIndex === 0 && !this.dialogStack.length) {
      this.dialogSubject.next(null);
    }
    if (this.dialogStack.length > 0) {
      this.dialogSubject.next(this.dialogStack[0]);
    }
  }

  private showDialog(dialog: ModalDialog): ModalDialog {
    if (dialog) {
      this.dialogStack.unshift(dialog);
    }
    this.triggerModal(dialog);
    return dialog;
  }

  private triggerModal(dialog: ModalDialog) {
    if (dialog) {
      this.subscription.add(dialog.onCancelSubject.subscribe(() => this.removeActiveDialog()));
      this.subscription.add(dialog.onOkSubject.subscribe(() => this.removeActiveDialog()));
    }
    this.dialogSubject.next(dialog);
  }

  private removeActiveDialog() {
    this.subscription.unsubscribe();
    this.subscription = new Subscription();
    this.dialogStack.splice(0, 1);
  }
}
